import React, { useState, useRef, useEffect } from 'react';
import useUserStore from '../../store/userStore';
import './LoginPopup.scss'; 
import useToastStore from '../../store/toastStore';
import { useLoadingStore } from '../../store/loadingStore';

const LoginPopup = ({ onClose }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useUserStore();
  const { showToast } = useToastStore();
  const popupRef = useRef(null); 
  const {setLoading} = useLoadingStore();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose(); 
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await login({ username: email, password }, showToast);
      setLoading(false);
      onClose();
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  return (
    <div className="login-popup-overlay">
      <div className="login-popup" ref={popupRef}>
        <div className="login-header">
          LOG IN
          
        </div>
        <div className='form-wrap'>
          <div className="form-group">
            <label htmlFor="email">e-mail:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="login-button" onClick={handleLogin}>
            LOG IN
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPopup;